import { Electricity, Gas } from "@/components/Icons";
import { CommodityEnum } from "@/types/contract";
import { Commodity } from "@/types/contract";
import { SVGProps } from "react";

const CommodityIcon = ({ commodity, ...iconProps }: { commodity: CommodityEnum } & SVGProps<SVGSVGElement>) => {
  return commodity === Commodity.Electricity ? (
    <Electricity {...iconProps} fontSize="1.5rem" />
  ) : (
    <Gas {...iconProps} fontSize="1.5rem" />
  );
};

export default CommodityIcon;
